import AllItemsStoreTeacher from "components/module/allItemsStoreTeacher"

const ClassStoreAllItemsTeacherPage = () => {
  return <AllItemsStoreTeacher />
}

export default ClassStoreAllItemsTeacherPage
